<template>

  <div class="all">
    <headercon></headercon>
    <div class="content">
      <el-carousel arrow="always"
                   class="ban"
                   trigger="click"
                   indicator-position="none"
                   ref="car"
                   :interval="0">
        <el-carousel-item v-for="(a, i) in goodsList"
                          :key="i">

          <div class="box">
            <div class="module">
              <div class="lun"
                   v-for="(item, i) in a"
                   :key="i"
                   @click="jump(item.id)">
                <div class="img1">
                  <img :src="item.image"
                       alt="">
                </div>
                <div class="text">
                  <p>{{item.title}}</p>
                </div>
                <p>{{item.create_time}}</p>
              </div>

            </div>

          </div>
        </el-carousel-item>

      </el-carousel>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import headercon from './header'
// eslint-disable-next-line no-unused-vars
import { Carousel, CarouselItem } from 'element-ui'
export default {
  components: {
    headercon,
    Carousel
  },
  data () {
    return {
      img: require('../assets/componylogo.png'),
      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们',
      goodsList: [],
      pageNum: 0,
      pageSize: 10000
    }
  },
  created () {
    this.setData()
  },
  methods: {
    getlist () {
      // const url = this.HOST + '/openApi/newsList'
      const url = this.HOST_NEW + '/yl/index.php/api/news'
      const that = this
      let arr2 = []
      // for (let a = 1; a < 10; a++) {
      // axios.get(url, { params: { prodId: this.prodId, pageNum: this.pageNum, pageSize: this.pageSize } })
      axios.post(url, { prodId: this.prodId, page: this.pageNum, pageSize: this.pageSize })
        .then(function (response) {
          let arr = response.data.data
          console.log(arr)
          // for (let i = 0; i < arr.length; i++) {
          //   let str = arr[i].create_time
          //   if ((i >= arr.length) || (str === 'undefined')) {
          //     break
          //   }
          //   let a = str.substring(0, 10)
          //   var date = new Date(a)
          //   var year = date.getYear() + 1900
          //   var month = date.getMonth() + 1
          //   var day = date.getDate()
          //   let date1 = year + '年' + month + '月' + day + '日'
          //   const object2 = Object.assign({ date: date1 }, arr[i])
          //   arr2.push(object2)
          // }
          that.goodsList = []
          let temp = []
          arr.forEach((k, i) => {
            if (i === 0 || i % 8 > 0) {
              temp.push(k)
            } else {
              if (i > 0 && i % 8 === 0) {
                that.goodsList.push(temp)
                temp = [k]
              }
            }
          })

          console.log('goodsList========', that.goodsList)
          // let count = Math.ceil(arr2.length / 8) // 有小数就整数部分加1
          // for (let i = 0; i < count; i++) {
          //   let arr1 = []
          //   for (let j = 0; j < 8; j++) {
          //     if (i * 8 + j >= arr2.length) {
          //       break
          //     }
          //     let item = arr2[i * 8 + j]
          //     arr1.push(item)
          //   }
          //   if (arr1.length !== 0) {
          //     that.goodsList.push(arr1)
          //   }
          // }
        })
        .catch(function (error) {
          console.log('999999' + error)
        })
    },
    jump (id) {
      console.log(id)
      this.$router.push({ path: '/newsdetail', query: { newsId: id } })
    },
    setData () {
      this.pageNum = this.pageNum + 1
      this.prodId = this.$route.params.prodId
      this.getlist(this.$route.params.prodId, this.pageNum)
    }

  }
}
</script>

<style scoped lang="less">
.all {
  background: url("../assets/details.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  /deep/ .li3 {
    list-style-type: none;
    float: left;
    border-radius: 25px;
    background: #fff;
    width: 100px;
    height: 30px;
    text-decoration: none;
    text-align: center;
    line-height: 30px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
  .content {
    width: 100%;
    height: 70%;
    margin: 3% auto;
    .but1 {
      margin-top: 20%;
      margin-left: -5%;
      width: 8%;
      height: 25%;
      font-size: 50px;
      background: linear-gradient(to right, #d5edfb, #eeffff);
    }
    .but2 {
      margin-top: 20%;
      margin-right: -5%;
      width: 8%;
      height: 25%;
      font-size: 50px;
      background: linear-gradient(to right, #eeffff, #d5edfb);
    }
    .box {
      width: 90%;
      height: 100%;
      margin: 0 auto;
      justify-content: space-between;
      display: flex;
      .module {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        .lun {
          width: 22%;
          height: 42%;
          margin-top: 20px;
          margin-left: 2%;
          border-radius: 20px;
          display: inline-block;
          background: linear-gradient(#eeffff, #d5edfb);
          vertical-align: top;
          .text {
            width: 80%;
            height: 23%;
            margin: 0px auto;
            position: relative;
            p {
              position: absolute;
              bottom: 0px;
              color: #5255a1;
              text-align: center;
            }
          }
          .img1 {
            height: 50%;
            width: 70%;
            border-radius: 20px;
            img {
              height: 100%;
              width: 100%;
              border-radius: 10px;
            }
          }
          p {
            margin-top: 5px;
            width: 100%;
            text-align: center;
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 1781px) {
  .lun {
    .text {
      p {
        font-size: 13px;
      }
    }
    .img1 {
      margin: 20px auto;
    }
    p {
      font-size: 10px;
    }
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1780px) {
  .lun {
    .text {
      p {
        font-size: 12px;
      }
    }
    .img1 {
      margin: 20px auto;
    }
    p {
      font-size: 10px;
    }
  }
}
@media only screen and (min-width: 1421px) and (max-width: 1600px) {
  .lun {
    .text {
      p {
        font-size: 12px;
      }
    }
    .img1 {
      margin: 20px auto;
    }
    p {
      font-size: 10px;
    }
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1420px) {
  .lun {
    .text {
      p {
        font-size: 10px;
      }
    }
    .img1 {
      margin: 10px auto;
    }
    p {
      font-size: 8px;
    }
  }
}
@media only screen and (max-width: 1200px) {
  .lun {
    .text {
      p {
        font-size: 10px;
      }
    }
    .img1 {
      margin: 10px auto;
    }
    p {
      font-size: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamic.vue